import React from 'react';
import { useAppContext } from '../../context/AppContext/AppContext';
import { Navigate, Outlet } from "react-router-dom";

export default function PrivateRoute({path, element}) {

    const {user} = useAppContext();

    if(!user || !user.email){
      return <Navigate to="/" />
    }

  return (
    <Outlet />
  )
}
